/**
 * WorkOS frontend configuration.
 *
 * Password login uses `POST /identity/auth/workos/login` exclusively.
 *
 * `VITE_WORKOS_CLIENT_ID` must match `WORKOS_CLIENT_ID` (AuthKit + dev tooling).
 */

/**
 * WorkOS client ID for AuthKitProvider.
 * Read from VITE_WORKOS_CLIENT_ID env var.
 */
export function getWorkOSClientId(): string {
  return (import.meta.env.VITE_WORKOS_CLIENT_ID as string | undefined) ?? '';
}

/**
 * WorkOS password login is always attempted when the form is submitted.
 */
export function isWorkOSEnabled(): boolean {
  return true;
}
